function ColoredText({ value, colorMap = {}, colorCondition = 'value' }) {
    const getColor = () => {
        const colorCssMap = {
            'green': 'var(--status-active)',
            'gray': 'var(--status-inactive)',
            'yellow': 'var(--status-pending)',
            'red': 'var(--status-blocked)',
        };
        return colorCssMap[colorMap[colorCondition]]
    };

    return (
        <span
            style={{
                color: getColor(),
                textTransform: 'capitalize',
                fontWeight: 500,
            }}
        >
            {value}
        </span>
    );
}

export default ColoredText;
